<div class="sid-steps mat-elevation-z1">
  <div class="sid-steps-step" [class.active]="step===1">
    <span class="sid-steps-number" [class.active]="step===1">
      1
    </span>
    <span class="sid-steps-title">ADD Self Indentified Deviation</span>
    <p class="sid-steps-desc">Fill Self Identified Deviation form</p>
  </div>
  <div class="sid-steps-step" [class.active]="step===2">
    <span class="sid-steps-number" [class.active]="step===2">
      2
    </span>
    <span class="sid-steps-title">Add CAPA/ECs & Submit</span>
    <p class="sid-steps-desc">Add all CAPA/ECs and when the list will be complete, click submit</p>
  </div>
  <div class="sid-steps-step" [class.active]="step===3">
    <span class="sid-steps-number" [class.active]="step===3">
      3
    </span>
    <span class="sid-steps-title">Wait for 1st approval</span>
    <p class="sid-steps-desc">Wait for approval by Subject Matter Expert. It coud take a few days</p>
  </div>
  <div class="sid-steps-step" [class.active]="step===4">
    <span class="sid-steps-number" [class.active]="step===4">
      4
    </span>
    <span class="sid-steps-title">Wait for 2nd approval</span>
    <p class="sid-steps-desc">Wait for approval by

        Chapter Lead.

        It coud take a few days</p>
  </div>
  <div class="sid-steps-step" [class.active]="step===5">
    <span class="sid-steps-number" [class.active]="step===5">
      5
    </span>
    <span class="sid-steps-title">Wait for Evidence Submission</span>
    <p class="sid-steps-desc">It could take a few days</p>
  </div>
  <div class="sid-steps-step" [class.active]="step===6">
    <span class="sid-steps-number" [class.active]="step===6">
      6
    </span>
    <span class="sid-steps-title">Wait for Evidence Approval</span>
    <p class="sid-steps-desc">It could take a few days</p>
  </div>
  <div class="sid-steps-step" [class.active]="step===7">
    <span class="sid-steps-number" [class.active]="step===7">
      7
    </span>
    <span class="sid-steps-title">SID complete</span>
    <p class="sid-steps-desc">Self Identified Deviaton is completed.</p>
  </div>

</div>